import { NamePath } from 'antd/es/form/interface'
import * as React from 'react'
import { FC } from 'react'
import Tube from '../../../../../../types/api/tube'
import { EditableContext } from '../editable-row'
import { Form, Select } from 'antd'
import { stampOrderOrderStatuses } from '../../../../../../constants/entity-enums/stamp-order-order-statuses'
import { EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import { useSaveOrder } from '../../../../helpers/use-save-order'

interface EditableSelectProps {
    namePath: NamePath
    record: Tube
    inputRef: any
    queryParams: EndpointQueryParameters

    toggleEdit: () => void
}

const EditableSelect: FC<EditableSelectProps> = ({
    namePath,
    record,
    inputRef,
    queryParams,
    toggleEdit,
}) => {
    const form = React.useContext(EditableContext)
    const saveOrder = useSaveOrder()
    const statusData = stampOrderOrderStatuses.map(item => ({ value: item, label: item }))
    const initialValue = record.stamps?.[0]?.last_order?.orderStatus

    const save = async () => {
        try {
            toggleEdit()
            if (!form) return
            const value = form.getFieldsValue()

            if (record.stamps?.[0]?.last_order) {
                const orderStatus = value?.stamps?.[0]?.last_order?.orderStatus
                if (orderStatus !== undefined && orderStatus !== initialValue) {
                    await saveOrder('orderStatus', orderStatus, record, queryParams)
                }
            }
        } catch (errInfo) {
            console.log('Save failed:', errInfo)
        }
    }
    return (
        <Form.Item
            initialValue={initialValue}
            style={{
                margin: 0,
            }}
            name={namePath}
        >
            <Select ref={inputRef} onChange={save} onBlur={save} options={statusData} />
        </Form.Item>
    )
}

export default EditableSelect
